import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "@/lib/api";

export default function ProtectedRoute({ children }) {
  const [status, setStatus] = useState("checking"); // "checking" | "authed" | "unauthed"

  useEffect(() => {
    let alive = true;
    api.get("/auth/me")
      .then(() => { if (alive) setStatus("authed"); })
      .catch(() => { if (alive) setStatus("unauthed"); });
    return () => { alive = false; };
  }, []);

  if (status === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--brand-cream)]" data-testid="auth-checking">
        <div className="text-[var(--brand-teal)] text-sm font-semibold">Verifying session...</div>
      </div>
    );
  }
  if (status === "unauthed") return <Navigate to="/admin/login" replace />;
  return children;
}
